// Canonical public base URL for Reference Pages and their QR codes.
// Production always uses the canonical domain (getciteqr.com), regardless of which host served the
// app, so QR codes and shared links are stable. Preview/local keep the current origin so the
// working environment stays testable. Existing /r/{id} routes and IDs are unchanged.
const CANONICAL = "https://getciteqr.com";

export function isDevHost() {
  const host = window.location.hostname || "";
  return host.includes("preview.emergentagent.com") || host === "localhost" || host.startsWith("127.") || host.endsWith(".local");
}

export function publicBaseUrl() {
  if (typeof window === "undefined") return CANONICAL;
  return isDevHost() ? window.location.origin : CANONICAL;
}

export function referencePageUrl(publicId) {
  return `${publicBaseUrl()}/r/${publicId}`;
}

// Same page, with a non-identifying marker so newly downloaded QR codes can be counted as QR visits.
export function referenceQrUrl(publicId) {
  return `${referencePageUrl(publicId)}?src=qr`;
}
